module.exports = __webpack_public_path__ + "img/carbon.b09af154.svg";